export default class NewsletterService {
  constructor(Api) {
    "ngInject"
    this.api = Api;

  }

  loadSubscribers(data) {
    let
      url = '/subscribers/list';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  removeSubscriber(id) {
    let
      url = `/subscribers/remove/${id}`;
    return this.api.call({
      method: 'delete',
      url
    })
  }

  getNewsletter(type) {
    let
      url = `/newsletter/get/${type}`;
    return this.api.call({
      method: 'get',
      url
    })
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/newsletter/services/newsletter.service.js
 **/